/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Operationhoursp22Inputs */



/**
* | output |
* | --- |
* | "Right/bottom pump operating hours" |
*
* @param {Ahu_History_Key_Operationhoursp22Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_operationhoursp22 = /** @type {((inputs?: Ahu_History_Key_Operationhoursp22Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Operationhoursp22Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Right/bottom pump operating hours")
	return /** @type {LocalizedString} */ ("Heures de fonctionnement pompe droite/basse")
});
export { ahu_history_key_operationhoursp22 as "ahu_history_key_operationHoursP2" }